/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.service('api', ['WebApi', '$filter', function (WebApi, $filter) {

        var _service = WebApi;
        
        /* auth */
        this.user = { 
            login: function (model) {
                return _service.post('/User/login?state=true', model);
            },
            loginFb: function (accessToken) {
                return _service.post('/User/loginFb?state=true', '"' + accessToken + '"');
            },
            logout: function () {
                return _service.get('/User/logout?state=true');
            },
            me: function () {
                return _service.get('/User/me?state=true');
            },
            detail: function () {
                return _service.get('/User/detail?state=true');
            },
            register: function (model) {
                return _service.post('/User/register?state=true', model);
            },
            forgot: function (model) {
                return _service.post('/User/NotifyCredential?state=true', model);
            },
            verifyEmail: function (model) {
                return _service.post('/User/VerifyEmail', model);
            },
            edit: function (model) {
                return _service.post('/User/edit?state=true', model);
            },
            editPassword: function (model) {
                return _service.post('/User/editPassword', model);
            },
            delete: function (model) {
                return _service.post('/User/delete', model);
            },
            wishlist: function () {                
                return _service.get('/User/wishlist?state=true');
            },
            addToWishlist: function (id) {                
                return _service.post('/User/wishlist?state=true', { id: id });
            },
            removeFromWishlist: function (id) {                
                return _service.delete('/User/wishlist/' + id + '?state=true');
            }
        };
        
        this.training = {
            all: function () { return _service.get('/training'); }, 
            latest: function () { return _service.get('/training/latest'); },
            top: function () { return _service.get('/training/top'); },
            target: function (id) { return _service.get('/training/target/' + id); },
            exercise: function (id) { return _service.get('/training/exercise/' + id); },
            tool: function (id) { return _service.get('/training/tool/' + id); },
            coach: function (id) { return _service.get('/training/coach/' + id); },
            me: function () { return _service.get('/training/coach/me?state=true'); },
            suggested: function () { return _service.get('/training/suggested?state=true'); },
            swimlist: function () { return _service.get('/training/swimlist?state=true'); },
            detail: function (id) { return _service.get('/training/' + id + '?state=true'); },
            save: function (model) { return _service.post('/training?state=true', model); }, 
            edit: function (model) { return _service.put('/training/' + model.id + '?state=true', model); },
            publish: function (id) { return _service.get('/training/publish/' + id + '?state=true'); }
        };

        this.coach = {
            top: function () {return _service.get('/coach/top')}, 
            chart: {
                all: function () { return _service.get('/coach/chart'); },
                page: function (page) { return _service.get('/coach/chart/' + page); },
                me: function () { return _service.get('/coach/chart/me?state=true'); }
            }
        }

        this.comment = {
            page: function (id) { return _service.get('/comment/page/' + id); },
            save: function (model) { return _service.post('/comment?state=true', model); }
        }
        
        this.data = {
            register: function () {
                return _service.get('/data/register');
            },
            contact: function () {
                return _service.get('/data/contact');
            },
            training: function () {
                return _service.get('/data/training');
            }
        };

        this.action = {
            contact: function (model) {
                return _service.post('/action/contact?state=true', model);
            },
            newsletter: function (model) {
                return _service.post('/action/newsletter', model);
            }            
        };

        this.glossary = function () { return _service.get('/glossary?state=true'); };

    }]);

}());